import React from 'react';

import { TitleImage } from '../../title-image';
import FaqItem from './faqs-item';

import { Wrapper } from '../../../utils/atoms';
import { FaqContainer, FaqList, FaqCol } from '../styles/faqs-block.style';

/**
 * FAQ Block Component
 * @returns {JSX} JSX for component
 */
const FaqBlock = ({ titleImage, faQs }) => {
  let faqList = [];
  if (faQs && faQs.length) {
    faqList = faQs.map((data, index) => <FaqItem key={index} {...data} />);
  }
  const cutOff = Math.ceil(faqList.length / 2);
  const col1 = faqList.slice(0, cutOff);
  const col2 = faqList.slice(cutOff);
  return (
    <Wrapper>
      <FaqContainer>
        <h1>
          <TitleImage src={titleImage && titleImage.file && titleImage.file.url} alt="FAQ" />
        </h1>
        <FaqList>
          <FaqCol>{col1}</FaqCol>
          <FaqCol>{col2}</FaqCol>
        </FaqList>
      </FaqContainer>
    </Wrapper>
  );
};

export default FaqBlock;



// WEBPACK FOOTER //
// ./src/components/faq/components/faqs-block.js